<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css'; // Import Swiper styles
import axiosApiClient from '@/axios'; // Import your Axios instance or use the default Axios import;

const partners = ref([{
    id: 1,
    description: 'Partner 1',
    thumbnail: '',
}]);
const getPartners = async () => {
    const { data } = await axiosApiClient.get('/api/partners');
    partners.value = data;
};
onMounted(async () => {
    await getPartners();
    const swiper = new Swiper('.mySwiper', {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 40,
            },
        },
    });
    const swiperButtonNext = document.querySelector('.swiper-button-next') as HTMLElement;
    const swiperButtonPrev = document.querySelector('.swiper-button-prev') as HTMLElement;
    swiperButtonNext.addEventListener('click', () => {
        swiper.slideNext();
    });
    swiperButtonPrev.addEventListener('click', () => {
        swiper.slidePrev();
    });
    const swiperWrapper = document.querySelector('.swiper-wrapper') as HTMLElement;
    swiperWrapper.addEventListener('mouseover', () => {
        swiper.autoplay.stop();
    });
    swiperWrapper.addEventListener('mouseout', () => {
        swiper.autoplay.start();
    });
});




</script>
<template>
    <div class="gap">
        <div class="container">
            <div class="swiper mySwiper">
                <div class="swiper-wrapper">
                    <div class="partner swiper-slide hover-img-two" v-for="partner in partners" :key="partner.id">
                        <figure class="imgg">
                            <img class="partner-image" :src="'data:image/png;base64,' + partner.thumbnail"
                                :alt="partner.description">
                            <img class="partner-image" :src="'data:image/png;base64,' + partner.thumbnail"
                                :alt="partner.description">
                        </figure>
                    </div>
                </div>
                <div class="swiper-button">
                    <div class="swiper-button-next"><i class="fa-solid fa-arrow-right"></i></div>
                    <div class="swiper-button-prev"><i class="fa-solid fa-arrow-left"></i></div>
                </div>
            </div>
        </div>
    </div>
</template>



<style lang="scss" scoped>
.partner-image {
    width: 30vw !important;
    height: 20vh !important;
    object-fit: cover !important;
}
</style>